import moment from "moment";
import { _pHttp } from "../_pHttp";

export async function searchUser({ nationalCode, matchId }: any) {
  const { data } = await _pHttp.get(`users/${nationalCode}/tickets/${matchId}`);
  return data;
}

export const downloadSpecificUserExcel = async (
  nationalC: any,
  matchId: number
) => {
  try {
    const response = await _pHttp.get(
      `users/${nationalC}/tickets/${matchId}/excel`,
      { responseType: "arraybuffer" }
    );

    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `nationalCode-${nationalC}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
    // Handle error (e.g., show error message to user)
  }
};

export const downloadUsersExcel = async (matchId: number) => {
  try {
    const response = await _pHttp.get(
      `ticket-matches/entry-report/excel/${matchId}`,
      {
        responseType: "arraybuffer",
      }
    );

    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    // const today = moment();
    // const formattedDate = today.format("YYYY-M-D");

    a.href = url;
    a.download = `matchId-${matchId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
    // Handle error (e.g., show error message to user)
  }
};
export const getFanReportList = async (params: { nationalCode: string }) => {
  const { data } = await _pHttp.get(`user-logs/nationalCode/${params.nationalCode}`);
  return data;
};

export const getPaginatedUserTickets = async ({
  nationalCode,
  matchId,
  page = 1,
  numberInPage = 10
}: {
  nationalCode: string
  matchId: number
  page?: number
  numberInPage?: number
}) => {
  const { data } = await _pHttp.get(
    `tickets/nationalCode/${nationalCode}/match/${matchId}`,
    {
      params: {
        page,
        numberInPage
      }
    }
  );
  return data;
};

export const getAllAttendeesPerMatch = async (
  matchId: number, 
  page: number = 1, 
  numberInPage: number = 10,
  search?: string
) => {
  try {
    const { data } = await _pHttp.get(`attendees/all/${matchId}`, {
      params: {
        page,
        numberInPage,
        search
      }
    });
    return data;
  } catch (error) {
    console.error("Error fetching attendees:", error);
    return null;
  }
};
export const getAllAttendees = async (
  page: number = 1, 
  numberInPage: number = 10,
  search?: string
) => {
  try {
    const { data } = await _pHttp.get(`attendees/all`, {
      params: {
        page,
        numberInPage,
        search
      }
    });
    return data;
  } catch (error) {
    console.error("Error fetching attendees:", error);
    return null;
  }
};


export const getFanReportLog = async (nationalCode: string) => {
  const { data } = await _pHttp.get(`user-logs/nationalCode/${nationalCode}`);
  return data;
};


export const getFanReportLogPerMatch = async (nationalCode: string, matchId: number) => {
  const { data } = await _pHttp.get(`user-logs/nationalCode/${nationalCode}/match/${matchId}`);
  return data;
};

export const getAllUsers = async (page: number = 1, numberInPage: number = 10, search?: string) => {
  try {
      const { data } = await _pHttp.get(`users`, {
      params: {
        page,
        numberInPage,
        search
      }
    });
    return data;
  } catch (error) {
        return null;
  }
};

export const getFanReportLogPerUserAll = async (
  userId: number,
  params: {
    page?: number | string;
    search?: string;
    numberInPage?: number | string;
  }
) => {
  try {
    const { data } = await _pHttp.get(`user-logs/userid/${userId}`, {
      params: {
        page: Number(params.page || 1),
        search: params.search || '',
        numberInPage: Number(params.numberInPage || 10)
      }
    });
    return data;
  } catch (error) {
    console.error("Error fetching user logs:", error);
    return { userLogs: [], totalRows: 0, totalPages: 0 };
  }
};

export const getFanReportLogAll = async (userId: number) => {
  const { data } = await _pHttp.get(`user-logs/all`);
  return data;
};

export const getFanReportLogAllMatch = async (
  nationalCode: string,
  params: {
    page?: number | string;
    search?: string;
    numberInPage?: number | string;
  }
) => {
  try {
    const { data } = await _pHttp.get(`user-logs/nationalCode/${nationalCode}`, {
      params: {
        page: params.page || 1,
        search: params.search || '',
        numberInPage: params.numberInPage || 10
      }
    });
    return data;
  } catch (error) {
    console.error("Error fetching user logs:", error);
    throw error;
  }
};

export const downloadAttendeesReportMatch = async (matchId: number) => {
  try {
    const response = await _pHttp.get(`attendees/report/${matchId}`, {
      responseType: "arraybuffer",
    });

    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `attendees-report-match-${matchId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading attendees report:", error);
    throw error;
  }
};

export const downloadUsersReport = async () => {
  try {
    const response = await _pHttp.get(`users/report`, {
      responseType: "arraybuffer",
    });

    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `users-report.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading users report:", error);
    throw error;
  }
};


